import { ThemePrepared } from "@fluentui/react-northstar";
import { themeNames } from "@fluentui/react-teams";
import React from "react";
import { openGroupChat } from "../../../utils/helper";
import AppCSS from "../TicketConversation.module.css";

interface GroupChatActivityProps {
  groupChat: any;
  circleImage: any;
  groupChatText: string;
  globalTheme: ThemePrepared<any>;
}

const GroupChatActivity: React.FC<GroupChatActivityProps> = ({
  groupChat,
  circleImage,
  groupChatText,
  globalTheme
}) => {
  if (!groupChat) return null;

  return (
    <div className={`${AppCSS.GroupChatArea} flex items-center`} onClick={() => openGroupChat(groupChat.ConversationId)} style={{ minHeight: '35px', margin: '0', ...(globalTheme.siteVariables.theme === themeNames.Dark && { backgroundColor: globalTheme.siteVariables.colorScheme.default.background })
      }}
    >
      <span style={{ maxWidth: '50px', float: 'left', paddingRight: '5px' }}>
        {circleImage}
      </span>
      <span style={{ padding: '0px 10px', color: globalTheme.siteVariables.colorScheme.default.foreground }}>{groupChatText}</span>
    </div>
  );
};

export default GroupChatActivity;
